//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import { Normalized } from '@utils/normalize';

export const getOrderedPosts = createSelector(
  (state: ICuralateStore) => state.instagram.schedule.scheduledPosts,
  (normalizedPosts) => Normalized.getOrdered(normalizedPosts),
);
